module.exports = __webpack_public_path__ + "img/Clients.fbc2ba0a.png";